import { render, staticRenderFns } from "./uom.vue?vue&type=template&id=a98d497c&"
import script from "./uom.vue?vue&type=script&lang=js&"
export * from "./uom.vue?vue&type=script&lang=js&"
import style0 from "./uom.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "uom.vue"
export default component.exports